module.exports = __webpack_public_path__ + "img/JE.72d25765.svg";